var GPC0114;
var GPC0114_Template;
$(document).ready(function() {
	if(!document.querySelector('.GPC0114')) return false;

	GPC0114 = function() {
		var $obj = $('.GPC0114');
		var runSlick = function($target) {
			if($target.find('.list-box .items .item').length>0) { // do not modify
				var num = [4, 3, 2, 1];				
				// LGEJP-750 start
				var stockListAutoPlayFlag = false;
				//	LGETH-525 Start
				if($obj.data('stocklistautorotationflag') == 'A' ){
					stockListAutoPlayFlag = true;
				}
				//	LGETH-525 End
				if($('html').data('countrycode').split('_')[0].toLowerCase() == 'jp') {
					num = [6, 4, 2, 1];
					//	stockListAutoPlayFlag = true;	//	LGETH-525 - 코드값을 통한 제어를 위해 주석처리.
				}
				// LGEJP-750 end 
				// LGEES-3220
				// Spain has six outputs on one screen, and other countries have four outputs on one screen.
				// same as GPC0125
				if($('html').data('countrycode').split('_')[0].toLowerCase() == 'es') {
					num = [6, 4, 2, 1];
				}
				// 20200316 START 박지영 : LGEAT-674 반영
				if($('html').data('countrycode').split('_')[0].toLowerCase() == 'at') {
					num = [5, 4, 2, 1];
				}
				// 20200316 END
				if($target.find('.list-box .items').hasClass('slick-initialized')) $target.find('.list-box .items').slick('unslick');
				/* LGECZ-39 : 20200917 modify */
				if($obj.data('stocklistautorotationflag') == 'Y' || $obj.data('stocklistautorotationflag') == 'A'){	//	LGETH-525 - add flag A
					$target.find('.list-box .items').slick({
						appendDots:$obj.find('.slick-indicator').find('.slick-dot-wrap'),
						infinite: true,
						listStyle: true,
						slidesToShow: num[0],
						slidesToScroll: 1,
						arrows : true,
						dots: true,
						autoplay: true,
						autoplaySpeed: 3000,
						responsive: [
							{
								breakpoint: 1200,
								settings: {
									autoplay: stockListAutoPlayFlag,	//	LGEJP-750 - replace with variable(original value false)
									slidesToShow: num[1],
									slidesToScroll: 1,
									arrows : true
								}
							},
							{
								breakpoint: 992,
								settings: {
									autoplay: stockListAutoPlayFlag,	//	LGEJP-750 - replace with variable(original value false)
									slidesToShow: num[2],
									slidesToScroll: 1,
									arrows : true
								}
							},
							{
								breakpoint: 768,
								settings: {
									autoplay: stockListAutoPlayFlag,	//	LGEJP-750 - replace with variable(original value false)
									slidesToShow: num[3],
									slidesToScroll: 1,
									dots: true,
									arrows: false
								}
							}
						],
						prevArrow: carouselOptions.bigAnglePrev, // common.js variable
						nextArrow: carouselOptions.bigAngleNext // common.js variable
					});
					
					if(num[0] < $target.find('.list-box .items .item').length){
						$obj.find('.slide-pause').addClass('active').on('click',function(e){
							e.preventDefault();
							if ($(this).hasClass('pause')) {
								$(this).removeClass('pause').addClass('play');
								$(this).text($(this).attr('data-title-play'));
								$target.find('.list-box .items').slick('slickPause');
							} else {
								$(this).removeClass('play').addClass('pause');
								$(this).text($(this).attr('data-title-stop'));
								$target.find('.list-box .items').slick('slickPlay');
							}
						});
					}else{
						$obj.find('.slick-indicator').hide();
					}					
				}else{
					$target.find('.list-box .items').slick({
						infinite: false,
						listStyle: true,
						slidesToShow: num[0],
						slidesToScroll: 1,
						arrows : true,
						dots: false,
						responsive: [
							{
								breakpoint: 1200,
								settings: {
									autoplay: false,
									slidesToShow: num[1],
									slidesToScroll: 1,
									arrows : true
								}
							},
							{
								breakpoint: 992,
								settings: {
									autoplay: false,
									slidesToShow: num[2],
									slidesToScroll: 1,
									arrows : true
								}
							},
							{
								breakpoint: 768,
								settings: {
									autoplay: false,
									slidesToShow: num[3],
									slidesToScroll: 1,
									dots: true,
									arrows: false
								}
							}
						],
						prevArrow: carouselOptions.bigAnglePrev, // common.js variable
						nextArrow: carouselOptions.bigAngleNext // common.js variable
					});
				}				
				/*// LGECZ-39 : 20200917 modify */
			} else {
				if(!$('body').hasClass('iw-fullscreen-edit')) $obj.parent().hide();
				/* LGECZ-39 : 20200917 add */
				if($obj.data('stocklistautorotationflag') == 'Y' || $obj.data('stocklistautorotationflag') == 'A') $obj.find('.slick-indicator').hide();	//	LGETH-525 - add flag A
				/*// LGECZ-39 : 20200917 add */
			}
		};
		// LGERU-285 WTB API change START
		var changeHTMLForRu = function(displayType, data, template, i) {
			if(!template) return '';
			// 20200416 START 박지영 UA 버전 추가
			if(displayType=='ru'){
			// 20200416 END
				var cid = decodeURI(getCookie('cid'));
				//LGCOMRU-212 Start
				var ruUrlLink = data.purchaseLink;
				if(!!getCookie('_ym_uid') && !!getCookie('_gid')){
					ruUrlLink += '?cid=' + getCookie('_ym_uid') + '|' + getCookie('_gid');
				}
				
				txt = template.replace(/\*url1\*/g, data.purchaseLink)
						.replace(/\*url2\*/g,  data.purchaseLink)
						.replace(/\*url\*/g,  ruUrlLink)
						.replace(/\*img\*/g, data.retailer.logo)
						.replace(/\*txt\*/g, data.retailer.name)
						.replace(/\*idx\*/g, i)
						;
				//LGCOMRU-212 End
			}
			return txt;
		}
		// LGERU-285 WTB API change END
		var changeHTML = function(displayType, data, template, i) {
			if(!template) return '';
			// 20200416 START 박지영 UA 버전 추가
			if(displayType=='ru' || displayType=='ua') {
			// 20200416 END
				var cid = decodeURI(getCookie('cid'));
				txt = template.replace(/\*url1\*/g, (!!getCookie('cid')) ? data.purchase_link+'&cid='+cid : data.purchase_link)
						.replace(/\*url2\*/g,  (!!getCookie('cid')) ? data.purchase_link+'&cid='+cid : data.purchase_link)
						.replace(/\*url\*/g,  (!!getCookie('cid')) ? data.purchase_link+'&cid='+cid : data.purchase_link)
						.replace(/\*img\*/g, data.logo)
						.replace(/\*txt\*/g, data.name)
						.replace(/\*idx\*/g, i)
						;
			} else if(displayType=='lg') {
				txt = template.replace(/\*url1\*/g, data.deeplink_url)
						.replace(/\*url2\*/g,  data.deeplink_url)
						.replace(/\*url\*/g,  data.deeplink_url)
						.replace(/\*img\*/g, data.logo_url)
						.replace(/\*txt\*/g, data.name)
						.replace(/\*idx\*/g, i)
						;
			/* LGEBR-226 add*/
			} else if(COUNTRY_CODE=='br') {
				//LGEBR-571 start
				/*
				console.log('GPC0114 data.url = ' + data.url);
				console.log('GPC0114 data.available = ' + data.available);
				console.log('GPC0114 availableTrueText = ' + $('input[name=availableTrueText]').val());
				console.log('GPC0114 availableTrueBtnName = ' + $('input[name=availableTrueBtnName]').val());
				console.log('GPC0114 availableFalseText = ' + $('input[name=availableFalseText]').val());
				console.log('GPC0114 availableFalseBtnName = ' + $('input[name=availableFalseBtnName]').val());
				*/
				if (data.available) {
					txt = template.replace(/\*url1\*/g, data.url)
						.replace(/\*url2\*/g, data.url)
					  	.replace(/\*url\*/g, data.url)
						.replace(/\*img\*/g, data.retailerLogo)
						.replace(/\*txt\*/g, data.retailer)
						.replace(/\*available\*/g, data.available)						
						.replace(/\*available_message\*/g, $('input[name=availableTrueText]').val())
						.replace(/\*available_btn_name\*/g, $('input[name=availableTrueBtnName]').val())
						.replace(/\*available_btn_type\*/g, 'btn-primary')
						.replace(/\*idx\*/g, i)
						;
				} else {
					txt = template.replace(/\*url1\*/g, data.url)
						.replace(/\*url2\*/g, data.url)
						.replace(/\*url\*/g, data.url)
						.replace(/\*img\*/g, data.retailerLogo)
						.replace(/\*txt\*/g, data.retailer)
						.replace(/\*available\*/g, data.available)						
						.replace(/\*available_message\*/g, $('input[name=availableFalseText]').val())
						.replace(/\*available_btn_name\*/g, $('input[name=availableFalseBtnName]').val())
						.replace(/\*available_btn_type\*/g, 'btn-outline-primary')
						.replace(/\*idx\*/g, i)
						;
				}
				//LGEBR-571 end
			/* //LGEBR-226 add*/
				/* LGETR-264 add*/
			} else if(displayType=='lgtrdata') {
				txt = template.replace(/\*url\*/g,  data.url)
						.replace(/\*img\*/g, data.logo)
						.replace(/\*txt\*/g, data.name)
						.replace(/\*idx\*/g, i)
						;
			} else {
				txt = template.replace(/\*url1\*/g, (data.homepage_url ? data.homepage_url : data.deeplink_url))
						.replace(/\*url2\*/g,  (data.deeplink_url ? data.deeplink_url : data.homepage_url))
						.replace(/\*url\*/g,  (data.deeplink_url ? data.deeplink_url : data.homepage_url))
						.replace(/\*img\*/g, data.logo_url)
						.replace(/\*txt\*/g, (displayType) ? data.display_name : data.name)
						.replace(/\*idx\*/g, i)
						;
			}
			return txt;
		};
		$obj.each(function() {
			$(this).find('.carousel-box').each(function() {
				// 20200311 START 박지영 - online 쿠키 배너 체크 해제 
				if($(this).is('[data-url]')) {
					//' 3rd party  (GPC0009, GPC0102, GPC0114)
					//if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_ANALYSIS_OF_SITE')) {
						var _this = $(this);
						// data('changedUrl')은 9번 컴포넌트에서 siblings 클릭시 추가해 줍니다.
						var url = (!!_this.data('changedUrl')) ? _this.data('changedUrl') : _this.data('url');
						var isDisplayName = _this.data("display-name");

						var dataType = 'json';
						var res = 'retailers';
						if(url.indexOf('lgwtb.lv') >=0) {
							dataType = 'jsonp';
							res = 'shops'
						}
						
						if(isDisplayName =='lgtrdata') {
							res = 'lgtrdata'
						}
						/* LGEBR-226, LGEBR-501 modify*/
						if(COUNTRY_CODE=='br'){
									
									_this.find('.no-items').hide();
									$obj.append('<div class="loading-circle"><div class="lds-dual-ring"></div></div>');
									$.ajax({
										type: 'GET',
									    url: url,
									    timeout: 20000,
									    dataType: "json",
									    success: function(data) { 
									    	
									    	if(_this.find('.list-box .items').hasClass('slick-initialized')) {
												_this.find('.list-box .items').slick('unslick').empty();
											}
											if(_this.find('template').length>0) GPC0114_Template = _this.find('template').clone().html();
											var html = '';
											if(data.status == 200 && data.status != undefined) {
												/* LGEBR-1126 start*/
												if(data.data !== undefined){
													var items = data.data.offers;
											    	var r = items;
											    	
													if(r.length>0) {
														for(i=0;i<r.length;i++) {
															if(data.products && data.products[0].model_code) _this.attr('data-model', data.products[0].model_code);
															if(r[i].instock != 'false') {
																html = html + changeHTML(isDisplayName, r[i], GPC0114_Template, i);
															}
														}
														if(html!='') {
															$obj.parent().show();
															_this.find('.list-box .items').html('<ul>'+xssfilter(html, 'html')+'</ul>');
															setTimeout(function() {
																runSlick(_this);
															}, 100);
														} else {
															_this.find('.no-items').show();
														}
														$obj.find('.loading-circle').remove();
													} else {
														$obj.find('.loading-circle').remove();
														_this.find('.no-items').show();
													}
													/* LGEBR-1126 end*/
												}else{
													$obj.find('.loading-circle').remove();
													_this.find('.no-items').show();
												}
											} else {
												$obj.find('.loading-circle').remove();
												_this.find('.no-items').show();
											}
									    },
									    error: function(request, status, error) {
									    	console.log("error!" + status);
									    	$obj.find('.loading-circle').remove();
									    	_this.find('.no-items').show();
										}
									});
								
						}else{ 	/* //LGEBR-226, LGEBR-501 modify*/
						ajax.call(String(url), {}, dataType, function(data){
							if(_this.find('.list-box .items').hasClass('slick-initialized')) {
								_this.find('.list-box .items').slick('unslick').empty();
							}
							if(_this.find('template').length>0) GPC0114_Template = _this.find('template').clone().html();
							// 아래 내용 수정 시, (GPC0009, GPC0102, GPC0114) 함께 수정 필요
							var html = '';
							if(data) {
								var r = '';
								/*LGETR-264 modify*/
								if(res == 'retailers') {
									// Channel Advisor, Intellibrand
									r = data.products[0].retailers;
								}else if(isDisplayName == 'lgtrdata'){
									r = data.retailers;
								} else {
									// lgwtb.lv (ee, lt, lv)
									r = data.shops;
								}
								if((res !== 'lgtrdata' && r.length>0) || (res == 'lgtrdata' && data.result>0)) {
									for(i=0;i<r.length;i++) {
										if(data.products && data.products[0].model_code) _this.attr('data-model', data.products[0].model_code);
										if(r[i].instock != 'false' && isDisplayName !== 'lgtrdata') {
											html = html + changeHTML(isDisplayName, r[i], GPC0114_Template, i);
										}else if(isDisplayName == 'lgtrdata') {
											if(r[i].availability != 0) {
												html = html + changeHTML(isDisplayName, r[i], GPC0114_Template, i);
											}
										}
										else if(COUNTRY_CODE == 'gr') {
											html = html + changeHTML(isDisplayName, r[i], GPC0114_Template, i);
										}
									}
									if(html!='') {
										$obj.parent().show();
										_this.find('.list-box .items').html('<ul>'+xssfilter(html, 'html')+'</ul>');
										setTimeout(function() {
											runSlick(_this);
										}, 100);
									} else {
										if(!$('body').hasClass('iw-fullscreen-edit')) $obj.parent().hide();
										else _this.find('.no-items').addClass('active');
									}
								} else {
									if(!$('body').hasClass('iw-fullscreen-edit')) $obj.parent().hide();
									else _this.find('.no-items').addClass('active');
								}
							} else {
								if(!$('body').hasClass('iw-fullscreen-edit')) $obj.parent().hide();
								else _this.find('.no-items').addClass('active');
							}
						}, 'get', $(this));
					}
						$(this).addClass('active');
					//} else {
					//	ePrivacyCookies.view('load', '', $(this));
					//	$(this).addClass('active');
					//}
				} else if($(this).is('[data-url-pattern]')) {
					// RU && UA
					//if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_ANALYSIS_OF_SITE')) {
					// LGERU-285 WTB API change START
						var shuffleArray = function (array) {
							// LGEUA-215 Start
							if(COUNTRY_CODE=='ua' || COUNTRY_CODE=='ru'){ // LGERU-212
								array.sort(function(a, b){
									return ( b.group === "" ) - ( a.group === "" ) || Number(b.group) - Number(a.group)
								});
							}else{
								for (var i = 0; i < array.length; i++) {
									var j = Math.floor(Math.random() * (i + 1));
									var temp = array[i];
									array[i] = array[j];
									array[j] = temp;
								}
							}
							// LGEUA-215 End
							return array;
						}
						var _this = $(this);
						// 20200416 START 박지영 UA 버전 추가
						var cc = COUNTRY_CODE.toLowerCase();
						var url = _this.attr('data-url-pattern').replace('\*BU\*', getBU('online'));
						var mpn = _this.attr('data-mpn');
						var displayType = _this.data("display-name"); // true or false
						if(cc!='ru'){
							ajax.call(url, {region: cc, mpn: mpn, callback: "success"}, 'jsonp', function(data){
								if(_this.find('.list-box .items').hasClass('slick-initialized')) {
									_this.find('.list-box .items').slick('unslick').empty();
								}
								if(_this.find('template').length>0) GPC0114_Template = _this.find('template').clone().html();
								// 아래 내용 수정 시, (GPC0112, GPC0102) 함께 수정 필요
								var html = '';
								if(data && data.iceleads_interface.status === 200) {
									if(data.iceleads_interface.retailers.retailer.length==0) {
										if(!$('body').hasClass('iw-fullscreen-edit')) $obj.parent().hide();
										else _this.find('.no-items').addClass('active');
									} else {
										var shops = shuffleArray(data.iceleads_interface.retailers.retailer),
											html = '';
										for (var i = 0; i < shops.length; i++) {
											// 20200408 START 박지영 : stock qty 체크 하여 제품이 있는 경우에만 출력하도록 변경
											if ((shops[i].stock_qty > 0) || (shops[i].stock_qty == "-99")) {
												html = changeHTML(cc, shops[i], GPC0114_Template, i) + html;
											}
											// 20200408 END
										}
										if(html!='') {
											$obj.parent().show();
											_this.find('.list-box .items').html('<ul>'+xssfilter(html, 'html')+'</ul>');
											setTimeout(function() {
												runSlick(_this);
											}, 100);
										} else {
											if(!$('body').hasClass('iw-fullscreen-edit')) $obj.parent().hide();
											else _this.find('.no-items').addClass('active');
										}
									}
								} else {
									if(!$('body').hasClass('iw-fullscreen-edit')) $obj.parent().hide();
									else _this.find('.no-items').addClass('active');
								}
							}, 'get', null);
						}else{
							$.ajax({
		                    	url: url,
		                        dataType: "json",
		                        type: "GET",
		                        data: {
		                            mpn: mpn
		                        },
		                        success: function (data) {
		                        	if(_this.find('.list-box .items').hasClass('slick-initialized')) {
										_this.find('.list-box .items').slick('unslick').empty();
									}
									if(_this.find('template').length>0) GPC0114_Template = _this.find('template').clone().html();
									var html = '';
		                            if (data.status === 200) {
										if(data.offers.length==0) {
											if(!$('body').hasClass('iw-fullscreen-edit')) $obj.parent().hide();
											else _this.find('.no-items').addClass('active');
										} else {
											var shops = shuffleArray(data.offers);
											if (getBuListCategory() == 'monitors') {
												for (var i = 0; i < shops.length; i++) {
													if (shops[i].retailer.id == '87553') {
														shops.push(shops.splice(i, 1)[0]);
													}
												}
											}
											for (var i = 0; i < shops.length; i++) {
												if (shops[i].retailer.id == '91239') {
													shops.push(shops.splice(i, 1)[0]);
												}
											}
											for (var i = 0; i < shops.length; i++) {
												// 20200408 START 박지영 : stock qty 체크 하여 제품이 있는 경우에만 출력하도록 변경
												if (shops[i].stockInfo) {
													html = changeHTMLForRu(cc, shops[i], GPC0114_Template, i) + html;
												}
												// 20200408 END
											}
											if(html!='') {
												$obj.parent().show();
												_this.find('.list-box .items').html('<ul>'+xssfilter(html, 'html')+'</ul>');
												setTimeout(function() {
													runSlick(_this);
												}, 100);
											} else {
												if(!$('body').hasClass('iw-fullscreen-edit')) $obj.parent().hide();
												else _this.find('.no-items').addClass('active');
											}
										}
		                            } else {
		                                if (!$('body').hasClass('iw-fullscreen-edit')) $obj.parent().hide();
		                                else list.find('.no-items').addClass('active');
		                            }
		                        },
		                        error: function (request, status, error) {
		                            // console.log(arguments);
		                        }
		                    });
						}
						// LGERU-285 WTB API change END
						// 20200416 END
						$(this).addClass('active');
					//} else {
					//	ePrivacyCookies.view('load', '', $(this));
					//	$(this).addClass('active');
					//}
				} else {
					//if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
						runSlick($(this));
						$(this).addClass('active');
					//} else {
					//	ePrivacyCookies.view('load', '', $(this));
					//	$(this).addClass('active');
					//}
				}
				// 20200311 END
			});
		});
	};
	GPC0114();
	
	//PJTGADL-2
	$('body').on('click',  '.GPC0114 .btn-primary', function () {
			var eventName = '';
			var storeContact = '';
			var store = '';
			var suffixCode = $('.js-compare').attr('data-model-suffixcode');
			var modelCode = $('.js-compare').attr('data-model-id');
			var msrp = $('.js-compare').attr('data-msrp');
			var price = $('.js-compare').attr('data-price');
			if(price == '.' || price == '.00' || price == '0.0'){
				price = "";
			} 
			if(msrp == '.' || msrp == '.00' || msrp == '0.0'){
				msrp = "";
			} 
				store = $(this).parents('.slick-slide').find('a').attr('adobe-onlinename');
				dataLayer.push({
					'event'			: 'buy_online_click',
					'superCategory'	: $('.js-compare').attr('data-category-name'),
					'category'		: $('.js-compare').attr('data-buname-two'),
					'subcategory'	: $('.js-compare').attr('data-buname-three'),
					'modelYear'		: $('.js-compare').attr('data-model-year'),
					'modelName'		: $('.js-compare').attr('data-model-name'),
					'modelCode'		: modelCode,
					'salesModelCode': $('.js-compare').attr('data-model-salesmodelcode'),
					'sku'			: $('.js-compare').attr('data-sku'),
					'suffix'        : suffixCode,
					'store'         : store,
					'bu'            : $('.js-compare').attr('data-buname-one'),
					'price'         : price,
					'currencyCode'  : $('.currency-code').val(),
					'dimension185'  : $('.navigation').attr('data-obs-group'),
					'metric4'       : msrp,
					'pdpTop'        : 'Y'
				});
			console.log('buy_online_click');
	});
	
	/* LGECN-214 Start */
	if(COUNTRY_CODE.toLowerCase() == 'cn'){
		$('.GPC0114').on('click', '.carousel-box a', function(){
			var go_to = $(this).find('.caption').text();
			baiduTrackEvent('go_to_'+go_to, $(this).parents().find('.GPC0009'), 'PDP');
		});
	}
	/* LGECN-214 End */
	
});
